import apiClient from "../../axios/apiClient";

  export const getUserTypePermissionListByUserTypeId =(token,id) =>
  async (dispatch) => {
    try {
      if(id==null)
      {
        return;
      }
      dispatch({ type: "GET_USERTYPE_PERMISSION_LISTBY_USERTYPE_ID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/role-permissions`,
        { params:{
             roleId:id
        },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_USERTYPE_PERMISSION_LISTBY_USERTYPE_ID_FULFILLED",
        payload: response.data?.data,
        usertypeCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_USERTYPE_PERMISSION_LISTBY_USERTYPE_ID_REJECTED",
        payload: error.response,
      });
    }
  };

export const updateUserTypePermissionData = (token, id,permissions) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_USERTYPE_PERMISSION__PENDING" });
    const data=permissions
    const response = await apiClient.put(
      `/api/v1/role-permissions/${id}`, // Endpoint URL with City ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_USERTYPE_PERMISSION__FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_USERTYPE_PERMISSION__REJECTED", payload: error.response });
  }
};
